<div>
	<div class="ibox-title">
		<h5>Today's Reasons for Visiting {{ Title }}</h5>
	</div>

	<div class="ibox-content">
		<!--Options-->
		<div class="ButtonGrid">
			<button
				[ngClass]="{
					btn: true,
					'btn-primary': OptionID != 0,
					'btn-warning': OptionID == 0
				}"
				(click)="SelectOption(0)"
			>
				Facility
			</button>

			<button
				[ngClass]="{
					btn: true,
					'btn-primary': OptionID != 1,
					'btn-warning': OptionID == 1
				}"
				(click)="SelectOption(1)"
			>
				District
			</button>
		</div>

		<!--Loading Overlay-->
		<div class="CenterDiv" *ngIf="loading == true">
			<p-progressSpinner></p-progressSpinner>
		</div>

		<!--Graph-->
		<div *ngIf="loading == false && chartData != undefined && lstVisitorReason.length > 0">
			<p-chart type="pie" [data]="chartData"></p-chart>

			<div class="Buttons">
				<button class="btn btn-primary" (click)="onRefreshColors()">Change Colors</button>
			</div>
		</div>

		<!--No Data-->
		<div
			*ngIf="loading == false && (chartData == undefined || lstVisitorReason.length == 0)"
			style="display: flex; justify-content: center; margin-top: 35px"
		>
			<h4>No Visitors Today</h4>
		</div>
	</div>
</div>
